var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefreshCw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "none",
    viewBox: "0 0 20 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.609
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#8D8D9A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.23 1.623V6.75h-5.034M.77 15.296v-5.128h5.034"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D9A",
    d: "M2.149 5.643a.77.77 0 101.453.505L2.15 5.643zm13.188-2.62l-.549.54a.98.98 0 00.017.016l.532-.555zM18.7 7.307a.77.77 0 101.064-1.111L18.7 7.307zM1.3 9.613a.77.77 0 00-1.064 1.112L1.3 9.613zm3.362 4.283l.549-.54a.744.744 0 00-.017-.016l-.532.556zm13.188-2.62a.77.77 0 00-1.453-.505l1.453.505zM3.602 6.148c.78-2.245 2.633-3.917 4.9-4.44L8.155.21C5.364.853 3.099 2.908 2.149 5.643l1.453.505zm4.9-4.44a6.692 6.692 0 016.286 1.855l1.098-1.078A8.231 8.231 0 008.156.209l.345 1.5zm6.303 1.871L18.7 7.306l1.064-1.111-3.894-3.727-1.064 1.111zM.237 10.725l3.894 3.726 1.064-1.111L1.3 9.613.237 10.725zm3.877 3.71a8.231 8.231 0 007.73 2.275l-.345-1.5a6.693 6.693 0 01-6.287-1.853l-1.098 1.077zm7.73 2.275c2.792-.643 5.057-2.699 6.007-5.434l-1.453-.505c-.78 2.245-2.633 3.917-4.9 4.44l.346 1.499z"
  }))));
}

export default __webpack_public_path__ + "./fonts/refresh-cw.153e4c3569fb7bc9e14b67669558e4da.svg";
export { SvgRefreshCw as ReactComponent };